$(function () {
	let $select = $('.js-select');
	// let $selectInput = $('.js-select-input');
	// let $selectFilter = $('.js-select-filter');


	let initSelect = function() {
		$('.js-select').select2({
			dropdownAutoWidth : true,
			containerCssClass: 'select',
			dropdownCssClass: 'no-input'
		});
	}
	initSelect();


	let initSelectLabel = function() {
		$('.js-select-label')
			.select2({
				dropdownAutoWidth : true,
				containerCssClass: 'select',
				dropdownCssClass: 'no-input'
			})
			.on('change', function(e){
				const labelTxt = $(e.target).attr('data-label');
				if(!labelTxt) return;
				const $selectionBox = $(e.target).siblings('.select2').find('.select2-selection__rendered');
				const labelTemplate = `<span class="select-label">${labelTxt}&nbsp;</span>`;
				$selectionBox.prepend(labelTemplate);
			})
			.trigger('change');

			$('.js-select-default')
				.select2({
					dropdownAutoWidth : true,
					containerCssClass: 'select',
					dropdownCssClass: 'no-input'
				})
	}
	initSelectLabel();

	// declaring for global visibility
	window.$select = $select;
	window.initSelect = initSelect;
	window.initSelectLabel = initSelectLabel;
	// window.$selectInput = $selectInput;
	// window.$selectFilter = $selectFilter;
	// window.initSelectInput = initSelect;
	// window.initSelectSearch = initSelect;
});

document.addEventListener("DOMContentLoaded", function() {
  
	// Обработчик события изменения выбора страны
	$('.js-select-ajax').on("change", function () {
		const val = $(this).val();
		const field = $(this).attr("name");

		const $citySelect = $(this).closest("form").find(".city-select");
		const $clubSelect = $(this).closest("form").find(".club-select");

		if (val) {
			$.ajax({
				url: $(this).data('url'),
				dataType: 'json',
				type: "GET",
				data: {
					field, //country or city
					val,
					action: 'get_regions' //нужен для wp
				},
				success: function (res) {
					if (field === 'country') {
						// Очищаем текущие опции города
						$citySelect.empty();

						const defaultOption = new Option("Город", "", true, true);
						defaultOption.disabled = true;
						$citySelect.append(defaultOption);

						const cities = res;

						// Добавить новые опции для городов с использованием Select2
						cities.forEach(function(city) {
							const option = new Option(city.name, city.id, false, false);
							$citySelect.append(option).trigger("change");
						});
					} else if (field === 'city') {
						$clubSelect.empty();

						const defaultOption = new Option("Клуб", "", true, true);
						defaultOption.disabled = true;
						$clubSelect.append(defaultOption);

						const clubs = res;

						clubs.forEach(function(club) {
							const option = new Option(club.name, club.name, false, false);
							$clubSelect.append(option).trigger("change");
						});
					}
				}
			});
		}
	});
});